<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div id="view">
        <img style="width: 100%;display: block;" class="top" src="http://static.yuread.cn/cps/editor/74.jpg" alt="">
        <div v-for="chapter in chapterlist" class="content">
            <h4>{{chapter.title}}</h4>
            <div v-html="chapter.content"></div>
        </div>

        <p class="p4" v-if="type==1">关注《{{wechat.nickname}}》公众号，继续阅读</p>

        <p class="tc" v-if="type==1">
            <button class="button"
                    v-clipboard:copy="wechat.search||wechat.nickname"
                    v-clipboard:success="copySuccess"
                    v-clipboard:error="copyError">一键复制公众号</button>
        </p>
        <p class="tc" v-if="type==1">
            <img src="./../assets/images/qqq.gif" alt="" class="img">
        </p>
        <div class="erweima" v-if="type==2">
            <h3>由于篇幅有限，保存微信二维码</h3>
            <h3>到微信阅读全文</h3>
            <img :src="'https://open.weixin.qq.com/qr/code?username='+wechat.username" alt="" class="weixin">
            <h3>长按二维码保存到相册</h3>
            <img src="./../assets/images/buzhou.jpeg" alt="" class="yingdao">
        </div>


    </div>
</template>

<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)


    export default {
        name: "Views",
        data(){
            return {
                chapterlist:[],
                wechat : {},
                success : false,
                alert : false,
                type : this.$route.query.type || 1
            }
        },
        methods : {
            getViewChapter(){
                this.axios.post('/api/chapter/getViewChapter',{
                    id : this.$route.params.id
                }).then(r => {
                    let data =r.data;
                    if(data.code){
                        this.chapterlist = data.data;
                        this.wechat = data.wechat
                    }
                })
            },
            copySuccess(){
                this.success = true;
                // this.axios.post('/api/link/addPv',{
                //     id : this.$route.params.id
                // }).then(r => {
                //     console.log(r.data);
                // })
                location.href="weixin://"

            },
            copyError(){
                alert("复制失败");
            }
        },
        created() {
            this.getViewChapter();
        }
    }
</script>

<style lang="less">
#view{background: #fbf7f9;
    .top{height: 400px;}
    .content{margin: 40px 0;padding: 0 20px;
        h4{font-size: 36px;text-align: center;color: #333;}
        p{font-size: 30px;line-height: 50px;margin-bottom: 20px;color: #666;}
    }
    .btn{text-align: center;
        button{background: orangered;color: #fff;font-size: 30px;width: 200px;height: 60px;border: none;border-radius: 60px;}
    }
    .wechat{text-align: center;padding: 40px;
        span{color: orangered;}
    }
    .p4{font-size: 40px;color: #13ce66;line-height: 100px;text-align: center}
    .button{background: orangered;border: none;color: #fff;width: 250px;height: 60px;border-radius: 60px;}
    .img{width: 90%;margin-top: 40px;}
    .guanzhu{position: fixed;top: 20px;left : 20px;right:20px;bottom: 20px;background: #fff;text-align: center;box-shadow: 0 0 20px #fff;z-index: 999;
        padding: 40px;overflow: auto;
        .p1,.p2{font-size: 40px;color: orange;margin-bottom: 40px;
            span{color: orangered;}
        }

        .p3{font-size: 36px;color: orangered;}




    }
    .success{font-size:30px;position: fixed;top: 0px;left : 0px;right:0px;bottom: 0px;z-index: 99999;background: #fff;height: 300px;margin: auto;text-align: center;padding: 80px 0 0;box-shadow: 0 0 60px #000;
        a{background: orangered;color: #fff;padding: 10px;line-height: 60px;}
        p{margin-bottom: 20px;}
    }
    .erweima{text-align: center;
        h3{color: orangered;font-size: 36px;}
        .weixin{width: 200px;}
        .yingdao{width: 90%;}
    }
}
</style>
